import { CheckBadgeIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";

import PunchClockRow from "./PunchClockRow";

import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import { useMemo } from "react";

const IntegrationPunchClock = ({ disabled, punchClocks, updatePunchClocks, saving }) => {
	const [data, setData] = useState([]);

	const addItemInArray = (value) => {
		const array = cloneDeep(data) || [];

		array.push(value);
		setData([...array]);
	};

	useEffect(() => {
		setData(punchClocks);
	}, [JSON.stringify(punchClocks)]);

	const allPunchClocksHaveSerial = useMemo(() => {
		return data?.every((pClock) => pClock?.serialNumber || pClock?.id);
	}, [JSON.stringify(data)]);

	return (
		<form>
			<div
				className="col-xs-12 pl-0 pr-0"
				style={{ marginBottom: 20 }}
			>
				<div className="col-xs-6">
					<h3>Punch Clocks</h3>
				</div>
				<button
					type="button"
					className="btn btn-primary pull-right"
					onClick={() => {
						addItemInArray({});
					}}
				>
					Add Clock
				</button>
			</div>
			{/** No items row? */}
			{punchClocks && data?.map((statePunchClock, index) => {
				const reduxPunchClock = punchClocks?.[index];

				const updatePunchClock = (value) => {
					const newData = cloneDeep(data);
					newData[index] = value;
					setData(newData);
				};

				return (
					<PunchClockRow
						key={index}
						disabled={disabled}
						pClock={reduxPunchClock}
						data={statePunchClock}
						setData={updatePunchClock}
					/>
				);
			})}
			<div className="col-xs-12 pr-0">
				<button
					className="btn btn-success pull-right"
					disabled={!data?.length || !allPunchClocksHaveSerial}
					type="button"
					onClick={() => {
						for (const pClock in data) {
							var finalClock = false;
							if (data.length - 1 <= pClock) finalClock = true;
							updatePunchClocks(data[pClock], finalClock);
						}
					}}
				>
					<CheckBadgeIcon style={{ height: "1.5em", float: "left" }} />
					<div style={{ float: "left", marginLeft: 5 }}>{(saving && "Saving...") || "Save"}</div>
				</button>
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	return {}
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationPunchClock);
